import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  fill: "none",
  viewBox: "0 0 30 30"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M27 26.05H3.547A.546.546 0 0 1 3 25.503V3.95h1.09v21.01H27"
    }, null, -1 /* CACHED */),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-width": ".5",
      d: "M27 26.05H3.547A.546.546 0 0 1 3 25.503V3.95h1.09v21.01H27"
    }, null, -1 /* CACHED */),
    _createElementVNode("path", {
      fill: "currentColor",
      stroke: "currentColor",
      "stroke-width": ".5",
      d: "M9.244 20.962h12.96L15.724 9.44zm13.65.807H8.554a.403.403 0 0 1-.354-.6l7.172-12.75c.144-.254.562-.254.703 0l7.172 12.75a.403.403 0 0 1-.353.6Z"
    }, null, -1 /* CACHED */),
    _createElementVNode("path", {
      fill: "currentColor",
      stroke: "currentColor",
      "stroke-width": ".5",
      d: "M16.134 17.478h-.822l-.228-2.503v-2.106h1.279v2.106zm-.409.725c.46 0 .831.353.831.816 0 .459-.372.812-.831.812a.816.816 0 0 1-.834-.812c0-.463.371-.816.834-.816Z"
    }, null, -1 /* CACHED */)
  ]))]))
}
export default { render: render }